import {useQuery, useMutation, useQueryClient} from '@tanstack/react-query';
import {fetchWidgetSettings, updateWidgetSettings} from './widget-settings-api';

/* ---------------------- READ ---------------------- */
export const useWidgetSettings = () =>
    useQuery({
        queryKey: ['widget-settings'],
        queryFn: fetchWidgetSettings,
    });

/* ---------------------- UPDATE ---------------------- */
export const useUpdateWidgetSettings = (onSuccess) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updateWidgetSettings,
        onSuccess: (data) => {
            // The PUT returns the full, fresh settings — prime the cache with it.
            queryClient.setQueryData(['widget-settings'], data);
            onSuccess?.(data);
        },
    });
};
